export default __webpack_public_path__ + "static/media/loupe_icon.ab7db28d.svg";